import React, { PropsWithChildren } from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { EditableTableTabHeaderProps } from "models/propTypes/genericFormProps";
//#endregion
//#region components
import { Grid } from "@mui/material";
import Icon from "../../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const EditableTableTabHeader: React.FC<PropsWithChildren<EditableTableTabHeaderProps>> = (props) => {
  const { tabContentHasError } = props;

  return (
    <Grid
      container
      direction="row"
      className={tabContentHasError ? cssExports.tabErrorIndicator : ""}
      alignItems="center"
    >
      {props.children}
      {tabContentHasError && <Icon icon={IconDefinitionConstants.WExclamation} />}
    </Grid>
  );
};

export default EditableTableTabHeader;
